import React from "react";
import ReactSelect from "react-select";
import { Text } from "@vagastec/ensemble-core";
import { errorMessageIconStyle, errorMessageStyle } from "./input-base.css";
import { vars } from "../theme.css";

export function Multi({
  name = "",
  options,
  required,
  onBlur = () => {},
  errorMessage = "",
  state = [],
  dataTestId,
  ...rest
}) {
  const [isAfterBlur, setIsAfterBlur] = React.useState(false);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "40px",
      border: `1px solid ${
        isAfterBlur && required && !state.length
          ? vars.color.errorForeground
          : "rgb(200, 200, 200)"
      }`,
      borderRadius: "6px",
      width: "100%",
      "&:hover": {},
    }),
  };

  return (
    <>
      <ReactSelect
        isMulti
        name={name}
        defaultValue={state}
        options={options}
        styles={customStyles}
        classNamePrefix="select"
        required={required}
        closeMenuOnSelect={false}
        onBlur={(e) => {
          setIsAfterBlur(true);
          onBlur(e);
        }}
        data-testid={dataTestId}
        {...rest}
      ></ReactSelect>
      {isAfterBlur && required && !state.length ? (
        <>
          <div className={errorMessageStyle}>
            <svg
              width={16}
              height={16}
              viewBox="0 0 24 24"
              fill="currentColor"
              className={errorMessageIconStyle}
            >
              <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm4.207 12.793l-1.414 1.414L12 13.414l-2.793 2.793-1.414-1.414L10.586 12 7.793 9.207l1.414-1.414L12 10.586l2.793-2.793 1.414 1.414L13.414 12l2.793 2.793z" />
            </svg>
            <Text size="sm" weight={600} as="p">
              {errorMessage}
            </Text>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );
}
